import { defineStore } from "pinia";
import type { TripService } from "@/services/socket/trip.service";
import type { TripOverview, TripOverviewTab } from "@/api/trips/dto/trip.dto";

interface TripStore {
  tripMonitorService: TripService | null;
  tripOverview: TripOverview | null;
  tripOverviewTab: TripOverviewTab;
  tripId: number | null;
}

export const useTripStore = defineStore("tripStore", {
  state: (): TripStore => ({
    tripMonitorService: null,
    tripOverview: null,
    tripOverviewTab: "trip-view",
    tripId: null,
  }),
  actions: {
    setTripMonitorService(service: TripService | null) {
      this.tripMonitorService = service;
    },
    updateTripOverview(data: TripOverview | null) {
      if (this.tripOverview && data) {
        if (this.tripOverview.id === data?.id) {
          this.tripOverview = data;
        }
      } else {
        this.tripOverview = data;
      }
    },
    updateTripOverviewTab(value: TripOverviewTab) {
      this.tripOverviewTab = value;
    },
  },
});
